import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryAddressHistoryPageable(data) {
  return request({
    url: URL.mdm.mscHistoryBillAddress.queryAddressHistoryPageable,
    method: 'post',
    data
  })
}

export function queryByUuid(params) {
  return request({
    url: URL.mdm.mscHistoryBillAddress.queryByUuid,
    method: 'get',
    params
  })
}

export function save(data) {
  return request({
    url: URL.mdm.mscHistoryBillAddress.save,
    method: 'post',
    data
  })
}

export function remove(params) {
  return request({
    url: URL.mdm.mscHistoryBillAddress.remove,
    method: 'delete',
    params
  })
}

